import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tuftsCard } from '../tufts-card/tufts-card';
import { ResizeController } from '../../controllers/resize-controller';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-clinical-trials-card.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import tuftsStyledTextgCssLit from '../tufts-styled-text/tufts-styled-text.css.lit';

/**
 * Clinical Trials Card component
 * @element tufts-clinical-trials-card
 *
 * @slot eyebrow
 * @slot short-heading
 * @slot heading
 * @slot icon-with-text
 * @slot cta
 * @attr border
 * @attr isSearchResult
 */
@customElement('tufts-clinical-trials-card')
export class tuftsClinicalTrialsCard extends tuftsCard {
  static styles: CSSResultGroup = [
    tuftsHeadingCssLit,
    tuftsStyledTextgCssLit,
    componentStyles,
  ];
  resizeController: ResizeController = new ResizeController(this);

  @property({ type: Boolean, reflect: true, attribute: 'border' })
  border: boolean;
  @property({ type: Boolean, reflect: true, attribute: 'is-search-result' })
  isSearchResult: boolean;

  render(): TemplateResult {
    const classes = {
      'main-wrapper': true,
      'border': !!this.border,
      'desktop': this.resizeController.currentBreakpointRange !== 0,
      'search-result': this.isSearchResult,
      [this.setColorTemplate()]: true,
    };

    return html`
      <article class="${classMap(classes)} ">
        ${this.ngSlot.conditionalNGSlot(
          'short-heading',
          true,
          this.isSearchResult ? 'xs' : 'xl'
        )}
        ${this.ngSlot.conditionalNGSlot(
          'heading',
          true,
          this.isSearchResult ? 'sm' : 'sm special-heading'
        )}
        ${this.ngSlot.conditionalNGSlot('table-refer')}
        ${this.ngSlot.conditionalNGSlot('icon-with-text')}
        ${this.ngSlot.conditionalNGSlot('cta')}
      </article>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-clinical-trials-card': tuftsClinicalTrialsCard;
  }
}
